<template>
  <div class="app-container">
    <el-card>
      <el-form size="small" label-position="top">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('routes.发车时间')">
              <span>{{ editRow.departureTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--流向名称-->
            <el-form-item :label="$t('routes.flowName')">
              <span>{{ editRow.flowDirectName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--发车转运中心-->
            <el-form-item :label="$t('routes.departureTransferCenter')">
              <span>{{ editRow.departTransferCenterName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--下一站流向-->
            <el-form-item :label="$t('routes.下一站流向')">
              <span>{{ editRow.nextSiteName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--应发件时间范围-->
            <el-form-item :label="$t('routes.DepartureTimeRange')">
              <span>{{ editRow.shipmentTimeScope }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!--应发袋数-->
      <el-tab-pane :label="$t('routes.NumberBagsSent')" name="1">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
        >
          <!--袋号-->
          <el-table-column :label="$t('GlobalSetObj.bagNumber')" prop="bagNumber" align="center" />
          <!--本场地最新操作-->
          <el-table-column :label="$t('routes.LatestOperationInThisArea')" prop="operateType" align="center" />
          <!--本场地最新操作时间-->
          <el-table-column :label="$t('routes.LatestOperationTimeInThisArea')" prop="operateTime" align="center" />
          <!--是否离场-->
          <el-table-column :label="$t('routes.WhetherToLeave')" prop="leaveSite" align="center" />
        </el-table>
      </el-tab-pane>
      <!--应发件数（正常）-->
      <el-tab-pane :label="$t('routes.NumberItemsToBeSent') + '(' + $t('placeOrder.Normal') + ')'" name="2">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
        >
          <!--安骏运单号-->
          <el-table-column :label="$t('orderCenterCont.anjunWaybillNumber')" prop="waybillNumber" align="center" />
          <!--最新操作-->
          <el-table-column :label="$t('collectionCenter.nowOperating')" prop="operateType" align="center" />
          <!--最新操作时间-->
          <el-table-column :label="$t('collectionCenter.nowOperatingTime')" prop="operateTime" align="center" />
          <!--本场地是否装车-->
          <el-table-column :label="$t('routes.IsThisAreaLoading')" prop="leaveSite" align="center" />
        </el-table>
      </el-tab-pane>
      <!--应发件数（大件）-->
      <el-tab-pane :label="$t('routes.NumberItemsToBeSent') + '(' + $t('placeOrder.big01') + ')'" name="3">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
        >
          <!--安骏运单号-->
          <el-table-column :label="$t('orderCenterCont.anjunWaybillNumber')" prop="waybillNumber" align="center" />
          <!--最新操作-->
          <el-table-column :label="$t('collectionCenter.nowOperating')" prop="operateType" align="center" />
          <!--最新操作时间-->
          <el-table-column :label="$t('collectionCenter.nowOperatingTime')" prop="operateTime" align="center" />
          <!--本场地是否装车-->
          <el-table-column :label="$t('routes.IsThisAreaLoading')" prop="leaveSite" align="center" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      :current-page.sync="queryForm.pageNumber"
      :page-size.sync="queryForm.pageSize"
      :page-sizes="[10, 50, 100, 200, 400]"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 20px 0; text-align: right"
      @size-change="detailSizeChange"
      @current-change="detailCurrentChange"
    />
  </div>
</template>
<script>
import { getOrderWaybillDailyDetail } from '@/api/logisticsOrders';

export default {
  props: {
    editRow: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          shipmentId: '',
          type: 1
        }
      },
      total: 0,
      activeName: '1',
      tableData: []
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    // 标签页切换
    handleClick(val) {
      this.activeName = val.name;
      this.queryForm.pageNumber = 1;
      this.tableData = [];
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      const param = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          shipmentId: this.editRow.id,
          type: Number(this.activeName)
        }
      };
      getOrderWaybillDailyDetail(param).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 每页显示数量选择
    detailSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 列表翻页
    detailCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped>

</style>
